import { Button } from '@myinterview/component-library';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  onClick: () => void;
}

export const StartNowButton:React.FC<IProps> = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <Button
      className="myinterview-widget-recording-action-button"
      onClick={onClick}
    >
      {t('buttons.btn_start_now')}
    </Button>
  );
};
